import { Link } from "react-router-dom";
import "../EntityTable.css";
import { memo } from "react";

interface LinkCellProps {
    route: string;
    value?: string | Record<string, unknown> | null | undefined;
    style?: React.CSSProperties;
    state?: Record<string, unknown>;
}

const LinkCell = memo(({ route, value, style, state }: LinkCellProps) => {
    const shownValue = getValue();
    return (
        <Link className="entityTable__linkCell" preventScrollReset={true} onClick={(e) => e.stopPropagation()} to={route} style={style} state={state}>
            {shownValue}
        </Link>
    );
    function getValue() {
        if (typeof value === "string" && value?.trim().length > 0) {
            return value.trim();
        }
        if (typeof value === "object" && value && "name" in value) {
            return value.name as string;
        }
        return "(none)";
    }
});

export default LinkCell;
